import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuFavoriteItem} from '@models/sidebar/response/menu-favorite-item';
import {MenuItem} from '@models/sidebar/menu-item';
import {DesignService} from '@services/left-menu/design/design.service';
import {SelectPageService} from '@services/left-menu/select-page/select-page.service';
import {ExternalUrlService} from '@services/left-menu/page/external-url-page/external-url.service';
import {FramePageService} from '@services/left-menu/page/frame-page/frame-page.service';
import { MenuItemType } from '@models/sidebar/menu-item-type';
import {Observable} from 'rxjs';
import {MenuItemComponent} from '@components/sidebar/menu-item/menu-item.component';

@Component({
    selector: 'scitis-favorite-item',
    templateUrl: './favorite-item.component.html',
    styleUrls: ['./favorite-item.component.scss'],
    standalone: false
})
export class FavoriteItemComponent  implements OnInit {

  @Input()
  menuFavoriteItem: MenuFavoriteItem = new MenuFavoriteItem();

  @Output()
  menuItemSelected: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  title: string = '';

  constructor(
      private designService: DesignService,
      private selectPageService: SelectPageService,
      private externalUrlService: ExternalUrlService,
      private framePageService: FramePageService) {
  }

  get parent(): string {
    return this.menuFavoriteItem.itemParentName;
  }

  get getSearchResultItemActiveClass(): string {
    if (String(this.menuFavoriteItem.id) === String(this.selectPageService.getSelectedPageId)) {
      return 'search-result-item-active';
    }
    return '';
  }

  get menuItem(): MenuItem {
    const menuItem: MenuItem = new MenuItem();
    menuItem.name = this.menuFavoriteItem.menuItemName;
    menuItem.id = this.menuFavoriteItem.id;
    menuItem.pageId = this.menuFavoriteItem.pageId;
    menuItem.type = this.menuFavoriteItem.type;
    menuItem.menuItemParent = new MenuItem();
    menuItem.menuItemParent.name = this.menuFavoriteItem.itemParentName;
    menuItem.menuItemParent.type = this.getParentType(this.menuFavoriteItem);
    if (menuItem.menuItemParent.type === MenuItemType.NODE) {
      menuItem.menuItemParent.id = this.menuFavoriteItem.nodeItemParentId;
      menuItem.nodeId = this.menuFavoriteItem.itemParentId;
    } else {
      menuItem.menuItemParent.id = this.menuFavoriteItem.itemParentId;
    }
    menuItem.icon = this.designService.getIcon(this.menuFavoriteItem.type);
    menuItem.favoriteToggle = true;
    menuItem.isFavorite = true;
    menuItem.machineId = this.getMachineId();
    menuItem.machineGroupId = this.getMachineGroupId();
    menuItem.url = this.menuFavoriteItem.url;
    menuItem.machineCategory = this.menuFavoriteItem.machineCategory;
    menuItem.firebaseUserId = this.menuFavoriteItem.firebaseParentId;

    return menuItem;
  }

  ngOnInit() {
    if (this.menuFavoriteItem.type === MenuItemType.EXTERNAL_URL || this.menuFavoriteItem.type === MenuItemType.FRAME_PAGE) {
      const observable = this.getUrlObservable(this.menuFavoriteItem);
      if (observable) {
        this.setUrl(observable);
      }
    }
  }

  private getUrlObservable(menuItem: MenuFavoriteItem): Observable<any> | undefined {
    const isParentMachineGroup = !menuItem.itemParentMachine;
    const parentId = menuItem.itemParentId.split('_')[1];
    if (menuItem.type === MenuItemType.EXTERNAL_URL && menuItem.pageId) {
      return this.externalUrlService.getExternalUrl(parentId, isParentMachineGroup, menuItem.pageId);
    }
    if (menuItem.type === MenuItemType.FRAME_PAGE) {
      return this.framePageService.getFramePage(parentId, isParentMachineGroup, menuItem.pageId);
    }
    return undefined;
  }

  private setUrl(observable: Observable<any>): void {
    observable.subscribe(urlResult => {
      if (this.menuFavoriteItem.pageId === urlResult.id) {
        this.menuFavoriteItem.url = urlResult.url;
      }
    });
  }

  onMenuItemSelected(menuItem: MenuItem): void {
    this.menuItemSelected.emit(menuItem);
  }

  getParentIcon() {
    return this.designService.getIcon(this.getParentType(this.menuFavoriteItem)) + ' mr-1';
  }

  triggerMenuItemClick(event: any, menuItemComponent: MenuItemComponent): void {
    menuItemComponent.onMenuItemSelected(event);
  }

  private getParentType(menuFavoriteItem: MenuFavoriteItem): MenuItemType {
    if (menuFavoriteItem.itemParentMachine) {
      return MenuItemType.MACHINE;
    } else if (menuFavoriteItem.isUserMenuItem && !menuFavoriteItem.itemParentMachine) {
      return MenuItemType.NODE;
    }
    return MenuItemType.MACHINE_GROUP;
  }

  private getMachineId(): string | null {
    if (this.menuFavoriteItem.type === MenuItemType.MACHINE) {
      const ids = this.menuFavoriteItem.menuItemId.split('_');
      if (ids && ids.length === 2) {
        return ids[1];
      }
    }
    return null;
  }

  private getMachineGroupId(): number | null {
    if (this.menuFavoriteItem.type === MenuItemType.MACHINE) {
      const ids = this.menuFavoriteItem.menuItemId.split('_');
      if (ids && ids.length === 2) {
        return Number(ids[0]);
      }
    }
    if (this.menuFavoriteItem.type === MenuItemType.MACHINE_GROUP) {
      return Number(this.menuFavoriteItem.menuItemId);
    }
    return null;
  }
}
